import React from "react";
import { Form, Flex, Select, Table, Button } from "antd";
import { Input } from "antd";
import CopyToClipboard from "../../components/copyToClipboard";
import { safeCall } from "../../utils/webview"; // 添加这一行

export default (props) => {
    const [dataSource, setDataSource] = React.useState({});
    const [form] = Form.useForm();
    const [page, setPage] = React.useState(1);
    const [total, setTotal] = React.useState(0);

    React.useEffect(() => {
        form.setFieldsValue({
            city: '杭州',
        });
    }, []);

    const cities = [
        { label: '杭州', value: '杭州' },
        { label: '长沙', value: '长沙' },
    ]

    const columns = [
        {
            title: '区',
            dataIndex: 'adname',
            key: 'adname',
        },
        {
            title: '名称',
            dataIndex: 'name',
            key: 'name',
            render: (text, record) => {
                return (
                    <div>
                        {text} 
                        {(typeof record.tel === 'string' && !!record.tel) && <CopyToClipboard text={text} />}
                    </div>
                )
            }
        },
        {
            title: '手机号',
            dataIndex: 'tel',
            key: 'tel',
            render: (text, record) => {
                return (
                    <div>
                        {(typeof text === 'string' && !!text) && text.split(';').map((item) => <div>
                            <a onClick={() => safeCall(item)}>{item}</a>
                        </div>)}
                        {/* {(typeof text === 'string' && !!text) && <CopyToClipboard text={text} />} */}
                    </div>
                )
            }
       },
    ];

    const onPageChange = async (value) => {
        console.log('onPageChange', value);
        search(value);
    }

    const onCityChange = (value) => {
        console.log('onCityChange', value);
        form.setFieldsValue({
            city: value,
        });

    }

    const onSearch = () => {
        search({current: 1});
    }

    const search = async ({current = 1}) => {
        const data = form.getFieldsValue();
        data.page = current;
        console.log('params', data);

        const params = new URLSearchParams(data);

        const response = await fetch(`/api/customer/discover?${params}`, {
            headers: {
                'Content-Type': 'application/json',
            }
        });

        const result = await response.json();
        console.log('result', result);

        if(result.success) {
            const count = +result.data?.count;
            setPage(current);
            setDataSource(result.data);
            if(count > 0) setTotal(count);
            console.log('setDataSource', +result.data?.count);
        }
    }

    return (
        <>
            <h2>客户开发</h2>
            <Form form={form}>
                <Flex gap={10} align="end">
                    <Form.Item label="选择城市" name={'city'}>
                        <Select options={cities} onChange={onCityChange} />
                    </Form.Item>

                    <Form.Item label="关键词" name={'keywords'} rules={[ { required: true, message: '请输入关键词' } ]}>
                        <Input placeholder="软装清洗" />
                    </Form.Item>

                    <Form.Item>
                        <Button onClick={onSearch} type="primary">搜索</Button>
                    </Form.Item>
                </Flex>
            </Form>

            <Table 
                onChange={onPageChange} 
                rowKey={(record)=> record.id}
                size="small" columns={columns} 
                dataSource={dataSource.pois || []} 
                pagination={{total, pageSize: 25, current: page, simple: true}}
            />
        </>
    )
}